const initialState = {
    showSuccessToast:false,
    showRejectToast:false,
    showApiErrorToast:false,
    showAgreementSuccessToast:false,
    showAgreementRejectToast:false
};

export const ToastReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_SUCCESS_TOAST':{
            return  {
                ...state,
                showSuccessToast:action.value,
                showRejectToast:false,
                showApiErrorToast:false,
                showAgreementSuccessToast:false,
                showAgreementRejectToast:false
            }
        }
        case 'SET_REJECT_TOAST':{
            return  {
                ...state,
                showRejectToast:action.value,
                showSuccessToast:false,
                showApiErrorToast:false,
                showAgreementSuccessToast:false,
                showAgreementRejectToast:false
            }
        }
        case 'SET_AGREEMENT_SUCCESS_TOAST':{
            return  {
                ...state,
                showAgreementSuccessToast:action.value,
                showAgreementRejectToast:false,
                showApiErrorToast:false,
                showSuccessToast:false,
                showRejectToast:false
            }
        }
        case 'SET_AGREEMENT_REJECT_TOAST':{
            return  {
                ...state,
                showAgreementRejectToast:action.value,
                showAgreementSuccessToast:false,
                showApiErrorToast:false,
                showSuccessToast:false,
                showRejectToast:false
            }
        }
        case 'SET_API_ERROR_TOAST':{
            return{
                ...state,
                showApiErrorToast:action.value,
                showRejectToast:false,
                showSuccessToast:false,
                showAgreementSuccessToast:false,
                showAgreementRejectToast:false
            }
        }
        default:
            return state;
    }

};

export default ToastReducer;
